import Column from "@components/column"
import SymptomForm from "./form"
import SymptomList from "./list"
const Symptoms = () =>{
    return (
        <Column rowGap={20}>
            <SymptomForm />
            <SymptomList />
        </Column>
    )
}

export default Symptoms